import ReactDOM from 'react-dom';
import { App } from './App';
import { mergeStyles, ThemeProvider } from '@fluentui/react';
import reportWebVitals from './reportWebVitals';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { BrowserRouter as Router } from "react-router-dom";
import { msalConfig } from "./authConfig";
// MSAL imports
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { appTheme } from './theme/theme';
import MSGraphService from './services/MSGraphService';

export const msalInstance = new PublicClientApplication(msalConfig);


export let graphInstance: MSGraphService;

initializeIcons();
// Inject some global styles
mergeStyles({
  ':global(body,html,#root)': {
    margin: 0,
    padding: 0,
    height: '100vh',
  },
});

// eslint-disable-next-line no-restricted-globals
// ReactDOM.render(<App />, document.getElementById('root'));

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });
  graphInstance = new MSGraphService();
  const rootElement = document.getElementById('root');
  if (rootElement) {
    ReactDOM.render(<Router>
      <ThemeProvider theme={appTheme}>
        <App pca={msalInstance} />
      </ThemeProvider>
    </Router>, document.getElementById('root'));
  } else {
    console.error('Root element not found');
  }

});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
